<template>
  <font-awesome-icon
    icon="ellipsis-h"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'

library.add(faEllipsisH)

export default {
  name: 'CoozzyMoreIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey-dark;
  }
</style>
